import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Enforce light theme only
if (typeof window !== 'undefined') {
    try {
        const stored = localStorage.getItem('theme-mode');
        if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed?.state?.mode === 'dark' || parsed?.mode === 'dark') {
                localStorage.setItem('theme-mode', JSON.stringify({ state: { mode: 'light' }, version: 0 }));
            }
        }
    } catch {
        localStorage.removeItem('theme-mode');
    }
}

const useThemeStore = create(
    persist(
        (set) => ({
            mode: 'light',
            setMode: () => set({ mode: 'light' }),
            toggleMode: () => set({ mode: 'light' }),
            initialize: () => {
                set({ mode: 'light' });
            },
        }),
        {
            name: 'theme-mode',
            partialize: () => ({ mode: 'light' }),
        },
    ),
);

export default useThemeStore;

